export default "__VITE_ASSET__ce89fc8b__"